import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GaTaggingFacade } from './+state/ga-tagging.facade';

@NgModule({
  imports: [CommonModule],
  providers: [GaTaggingFacade],
})
export class CommonDataAccessGaTaggingModule {}
